const smtpConfig = {
    host: process.env.GATSBY_API_URL,
    action: process.env.GATSBY_API_SEND,
    auth: process.env.GATSBY_API_AUTH,
    user: process.env.GATSBY_API_USER,
    pass: process.env.GATSBY_API_PASS,
}
export default smtpConfig